import { Button, Card, Title3 } from '@fluentui/react-components';

export const EmptyState = ({ title, description, actionLabel, onAction }: { title: string; description: string; actionLabel?: string; onAction?: () => void }) => (
  <Card>
    <Title3>{title}</Title3>
    <p>{description}</p>
    {actionLabel && onAction ? <Button onClick={onAction}>{actionLabel}</Button> : null}
  </Card>
);
